"use strict";
import { useQuery } from "@tanstack/react-query";
import { numberToHex } from "viem";
import { useAccount, useConnectorClient } from "wagmi";
export function useEip5792Support(chainId) {
  const { connector, address, chainId: accountChainId, isConnected } = useAccount();
  const resolvedChainId = chainId ?? accountChainId;
  const { data: client, isLoading: clientLoading } = useConnectorClient({ connector });
  const enabled = Boolean(isConnected && address && resolvedChainId && client);
  const { data, isFetching } = useQuery({
    queryKey: ["eip5792-atomic-support", connector?.uid, address, resolvedChainId],
    enabled,
    staleTime: 3e4,
    refetchInterval: 3e4,
    retry: false,
    queryFn: async () => {
      if (!client || !address || !resolvedChainId) return false;
      let timeout;
      try {
        const capabilities = await Promise.race([
          client.request({
            method: "wallet_getCapabilities",
            params: [address, [numberToHex(resolvedChainId)]]
          }),
          new Promise((_, reject) => {
            timeout = setTimeout(() => reject(new Error("Wallet capabilities timed out")), 5e3);
          })
        ]);
        return capabilities[numberToHex(resolvedChainId)]?.atomic?.status === "supported";
      } catch {
        return false;
      } finally {
        clearTimeout(timeout);
      }
    }
  });
  return {
    supported: enabled && data === true,
    isLoading: Boolean(isConnected && (clientLoading || enabled && data === void 0 && isFetching))
  };
}
